var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect" },
    [
      _c(
        "v-container",
        { attrs: { "grid-list-xl": "" } },
        [
          _vm.pageName
            ? _c("CmsBlock", { attrs: { blockName: _vm.pageName } })
            : _c("div", [
                _c("h2", { staticClass: "myTitle" }, [
                  _vm._v("Seite nicht gefunden"),
                ]),
                _c("div", { staticClass: "spacer-25" }),
                _c(
                  "div",
                  { staticClass: "spacer-25 text-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "btn-df okBtn", rounded: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.$ebus.$emit("gotoStart")
                          },
                        },
                      },
                      [_vm._v(" Zur Startseite ")]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "spacer-25" }),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }